/* eslint-disable no-console */
/* eslint-disable unused-imports/no-unused-vars */
import React, { useEffect, useRef, useState, useMemo } from "react";
import DOMPurify from "dompurify";
import { useSelector } from "react-redux";
import { Tab } from "react-bootstrap";
import axios from "axios";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";

import { api_without_cancellation } from "../../../api/api";
import "../ClientCommunication.css";
import "./ClientCommunicationTabs.css";
import {
  addClickRecord,
  formatPhoneNumber,
  getCaseId,
  getClientId,
  getToken,
} from "../../../Utils/helper";
import "../css/client-communication.css";
// import avatar from "../../../../public/bp_assets/img/avatar_new.svg";
import avatarImage from "../../../assets/images/avatar.svg";
import TextViewResponseModal from "../../ClientDashboard/modals/clientTableViewTextModal";
import ChatIcon from "../../../assets/images/client-icons/chat-icon-color.svg";
import NewPhoneIcon from "../../../assets/NewPhoneIcon";
import AddIcon from "../../../assets/Add-icon-gold.svg";
import ModalBodyMessage from "../../ClientDashboard/modals/clientMessageModal";
import UserChatBubble from "../../Forms/FirmUserBtn";
import { useDocumentModal } from "../../common/CustomModal/CustomModalContext";
import DraftsLogo from "../../../assets/drafts/Drafts-icon.svg";
import transcptionIcon from "../../../assets/recording/transcription.svg";
import phoneRecordIcon from "../../../assets/recording/phone-record.svg";
import { PhotoSlot } from "../../../Modules/NewCasePage";
import DefaultThumbnail from "../../common/defaultPhotoSlot";
import CommunicationModal from "../modals/communication-modal";
import SmartResponsiveTabsContainer from "../../DefendantPage/DefandantMain/components/ResponsiveTabDefendants";
import NewRejectedIcon from "../../../assets/NewRejectedIcon";

import useClientPage from "./contact-panel/hooks/useClientPage";
import AddPhoneCallModal from "./phone-call-modal";
import AddLetterPopup from "./letter-call-modal";
import EmailReplyModal from "./email-reply-modal";
import NewEmailModal from "./NewEmailModal";
import { useClientCommunications } from "./client-communication/hooks/useClientCommunications";
import TranscriptionModal from "./TranscriptionModal";
import RecordingPlayerModal from "./CallRecordingModal";

const ClientCommunication = () => {
  const origin = process.env.REACT_APP_BACKEND_URL;
  const token = getToken();
  const clientId = getClientId();
  const caseId = getCaseId();
  const [activeTab, setActiveTab] = useState("all");
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);

  const [textViewResponseModalShow, setTextViewResponseModalShow] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [emailReplyModalShow, setEmailReplyModalShow] = useState(false);
  const [unreadEmailCount, setUnreadEmailCount] = useState(0);

  const {
    all,
    chat,
    text,
    email,
    letter,
    phone,
    call,
    loading,
    refetch_data,
    addCommunication,
    pagination,
    loadTabInitial,
    goToNextPage,
    goToPrevPage,
    markItemAsReviewed,
  } = useClientCommunications(clientId, caseId, token);
  console.log(all);
  // Pagination widget component for table headers
  const PaginationWidget = ({ tabKey }) => {
    const tabPagination = pagination[tabKey];
    return (
      <div
        style={{
          position: "absolute",
          right: 5,
          top: "50%",
          transform: "translateY(-50%)",
          display: "flex",
          alignItems: "center",
          gap: 4,
        }}
      >
        <button
          className="btn p-0 height-25 d-flex align-items-center justify-content-center"
          style={{
            width: 20,
            border: "none",
            background: "transparent",
            color: !tabPagination.hasPrev ? "var(--primary-25)" : "var(--primary)",
            cursor: tabPagination.hasPrev ? "pointer" : "not-allowed",
          }}
          onClick={() => goToPrevPage(tabKey)}
          disabled={!tabPagination.hasPrev || tabPagination.loading}
          title="Previous page"
        >
          <FaChevronLeft size={10} />
        </button>
        <span
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: "var(--primary)",
            minWidth: 16,
            textAlign: "center",
          }}
        >
          {tabPagination.page}
        </span>
        <button
          className="btn p-0 height-25 d-flex align-items-center justify-content-center"
          style={{
            width: 20,
            border: "none",
            background: "transparent",
            color: !tabPagination.hasNext ? "var(--primary-25)" : "var(--primary)",
            cursor: tabPagination.hasNext ? "pointer" : "not-allowed",
          }}
          onClick={() => goToNextPage(tabKey)}
          disabled={!tabPagination.hasNext || tabPagination.loading}
          title="Next page"
        >
          <FaChevronRight size={10} />
        </button>
      </div>
    );
  };

  // Listen to global WebSocket messages via custom event
  useEffect(() => {
    const handleGlobalWebSocketMessage = (event) => {
      const message = event.detail;
      console.log("📨 Component received WebSocket message:", message);

      // Note: We receive messages for the current client because the WebSocket
      // is connected to this specific client/case endpoint. No need to filter.
      // The backend only sends messages relevant to this WebSocket connection.

      switch (message.type) {
        case "incoming_text_message":
          addCommunication(message.data, "text");
          showNotification("📱 New text message received");
          playNotificationSound();
          break;

        case "outgoing_text_message":
          addCommunication(message.data, "text");
          break;

        case "email":
          addCommunication(message.data, "email");
          showNotification("📧 New email received");

          // Update unread count if email is from client
          if (message.data.from_user === "client" && !message.data.is_read) {
            setUnreadEmailCount((prev) => prev + 1);
          }
          break;

        case "chat_message":
          addCommunication(message.data, "chat");
          break;

        case "phone_call_log":
          addCommunication(message.data, "phone");
          showNotification("📞 New phone call log added");
          break;
        case "OutboundRecordedCall":
          addCommunication(message.data, "call");
          showNotification("📞 New Call Recording Call log added");
          break;
        case "InboundRecordedCall":
          addCommunication(message.data, "call");
          showNotification("📞 New Call Recording Call log added");
          break;
        case "letter_log":
          addCommunication(message.data, "letter");
          showNotification("📄 New letter log added");
          break;

        default:
          console.warn("Unknown WebSocket message type:", message.type);
      }
    };

    // Listen for global WebSocket messages
    window.addEventListener("clientCommunicationMessage", handleGlobalWebSocketMessage);

    return () => {
      window.removeEventListener("clientCommunicationMessage", handleGlobalWebSocketMessage);
    };
  }, [clientId, caseId, addCommunication]);

  // Helper functions for notifications
  const showNotification = (message) => {
    // Browser notification (if permission granted)
    if ("Notification" in window && Notification.permission === "granted") {
      new Notification("New Communication", { body: message });
    } else if ("Notification" in window && Notification.permission === "default") {
      // Request notification permission on first use
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          new Notification("New Communication", { body: message });
        }
      });
    }

    // You can also integrate with a toast library here
    // Example: toast.success(message);
    console.log("🔔 Notification:", message);
  };

  const playNotificationSound = () => {
    try {
      // You can add a notification sound file to your public folder
      // const audio = new Audio('/notification-sound.mp3');
      // audio.play().catch(e => console.log('Could not play sound:', e));
    } catch (error) {
      console.log("Could not play notification sound:", error);
    }
  };

  const [showChatModal, setShowChatModal] = useState(false);
  const [showTextModal, setShowTextModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showLetterModal, setShowLetterModal] = useState(false);
  const [showPhoneCallModal, setShowPhoneCallModal] = useState(false);
  const { clientData, refetch } = useClientPage(clientId, caseId);
  const { showDocumentModal } = useDocumentModal();
  const userPreferences = JSON.parse(localStorage.getItem("userPreferences") || "{}");
  const abbrUserName = userPreferences.AbbrUserName || 1;
  const formatPhoneNumber3 = (phone) => {
    const digits = String(phone).replace(/\D/g, "");
    const d = digits.slice(-10);
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  };
  const getDisplayName = (first, last) => {
    const abbr = (name) => (name ? `${name.charAt(0).toUpperCase()}.` : "");
    switch (abbrUserName) {
      case 2:
        return `${abbr(first)} ${last}`;
      case 3:
        return `${first} ${abbr(last)}`;
      case 4:
        return `${abbr(first)} ${abbr(last)}`;
      default:
        return `${first} ${last}`;
    }
  };
  const handleTextMessageClick = (message) => {
    setTextViewResponseModalShow(true);
    setSelectedMessage(message);
  };

  const handleEmailMessageClick = async (email) => {
    setSelectedEmail(email);
    setEmailReplyModalShow(true);

    // Mark email as read if it's unread
    if (!email.is_read) {
      try {
        await axios.post(
          `${origin}/api/client-page/emails/mark-read/`,
          { email_id: email.id },
          {
            headers: {
              Authorization: token,
            },
          }
        );
        // No need to refetch - WebSocket will provide real-time updates
        fetchUnreadCount();
      } catch (error) {
        console.error("Error marking email as read:", error);
      }
    }
  };

  const fetchUnreadCount = async () => {
    try {
      const response = await axios.get(
        `${origin}/api/client-page/emails/unread-count/${clientId}/`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      setUnreadEmailCount(response.data.count || 0);
    } catch (error) {
      console.error("Error fetching unread count:", error);
    }
  };

  const handleAddClick = () => {
    switch (activeTab) {
      case "chat":
        setShowChatModal(true);
        break;
      case "text":
        setShowTextModal(true);
        break;
      case "email":
        setShowEmailModal(true);
        break;
      case "letter":
        setShowLetterModal(true);
        break;
      case "phone_call":
        setShowPhoneCallModal(true);
        break;
      default:
        console.warn("Unknown tab:", activeTab);
    }
  };

  // Helper to get date string for grouping
  const getDateKey = (item) => {
    const dateValue =
      item.date || item.date_received || item.obj?.created_at || item.obj?.timestamp;
    if (!dateValue) return null;
    return new Date(dateValue).toISOString().slice(0, 10);
  };

  // Helper to get datetime for display
  const getDateTime = (item) => {
    return item.date || item.date_received || item.obj?.created_at || item.obj?.timestamp;
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get("comm_tab");
    if (tab && ["chat", "text", "email", "letter", "phone_call"].includes(tab)) {
      setActiveTab(tab);
      loadTabInitial(tab);
      params.delete("comm_tab");
      const qs = params.toString();
      window.history.replaceState(null, "", window.location.pathname + (qs ? `?${qs}` : ""));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Helper to get "From" value based on type
  const getFromValue = (item) => {
    if (item.comm_type === "Email" || item.type === "Email") {
      // return item.sender;
      return (
        <>
          {item?.sent_by_user?.user_type === "Client" ? (
            <div className="d-flex align-items-center">
              <div
                className="image-container-modal"
                style={{
                  width: "19px",
                  height: "19px",
                }}
              >
                <img
                  src={item?.sent_by_user?.profile_pic ?? avatarImage}
                  // alt={}
                  style={{
                    width: "19px",
                    height: "19px",
                    background: "var(--primary-30)",
                  }}
                />
                {/* <div className="border-overlay-modal" /> */}
              </div>
              <p className="ps-1">
                {getDisplayName(item?.sent_by_user?.first_name, item?.sent_by_user?.last_name)}
              </p>

              {/* <p className="ps-1">{item?.sent_by_user?.last_name}</p>
              <span className="text-dark-grey">,</span>&nbsp;
              <p>{item?.sent_by_user?.first_name}</p> */}
            </div>
          ) : (
            <div className="d-flex align-items-center">
              <UserChatBubble
                userId={item?.sent_by_user?.id}
                first_name={item?.sent_by_user?.first_name || ""}
                last_name={item?.sent_by_user?.last_name || ""}
                profilePic={item?.sent_by_user?.profile_pic ?? ""}
                isActive={userOnlineStatus?.[item?.sent_by_user?.id]?.isOnline ?? false}
                is_active={item?.sent_by_user?.is_active}
                width={19}
              />
            </div>
          )}
        </>
      );
    }
    if (item.type === "ChatMessage") {
      const user = item.obj?.user;
      if (typeof user === "object" && user) {
        return (
          <>
            {item?.obj?.user?.user_type === "Client" ? (
              <div className="d-flex align-items-center">
                <div
                  className="image-container-modal"
                  style={{
                    width: "19px",
                    height: "19px",
                  }}
                >
                  <img
                    src={item?.obj?.user?.profile_pic ?? avatarImage}
                    // alt={avatar}
                    style={{
                      width: "19px",
                      height: "19px",
                      background: "var(--primary-30)",
                    }}
                  />
                  {/* <div className="border-overlay-modal" /> */}
                </div>
                {/* <p className="ps-1">{item?.obj?.user?.last_name}</p>
                <span className="text-dark-grey">,</span>&nbsp;
                <p>{item?.obj?.user?.first_name}</p> */}

                <p className="ps-1">
                  {getDisplayName(item?.obj?.user?.first_name, item?.obj?.user?.last_name)}
                </p>
              </div>
            ) : (
              <div className="d-flex align-items-center">
                <UserChatBubble
                  userId={item?.obj?.user?.id}
                  first_name={item?.obj?.user?.first_name || ""}
                  last_name={item?.obj?.user?.last_name || ""}
                  profilePic={item?.obj?.user?.profile_pic ?? ""}
                  isActive={userOnlineStatus?.[item?.obj?.user?.id]?.isOnline ?? false}
                  is_active={item?.obj?.user?.is_active}
                  width={19}
                />
              </div>
            )}
          </>
        );
      }
      return user;
    }
    if (item.type === "TextMessage" || item.type === "IncomingTextMessage") {
      const sender = item.obj?.sender;
      console.log(sender);
      console.log(typeof sender);
      if (typeof sender === "object" && sender) {
        return (
          <>
            {item?.obj?.sender?.user_type === "Client" ? (
              <div className="d-flex align-items-center">
                <div
                  className="image-container-modal"
                  style={{
                    width: "15px",
                    height: "15px",
                  }}
                >
                  <img
                    src={item?.obj?.sender?.profile_pic ?? avatarImage}
                    // alt={avatar}
                    className="d-flex aligm-items-center justify-content-center"
                    style={{
                      width: "15px",
                      height: "15px",
                      background: "var(--primary-30)",
                    }}
                  />
                  {/* <div className="border-overlay-modal" /> */}
                </div>
                <p className="ps-1">
                  {getDisplayName(item?.obj?.sender?.first_name, item?.obj?.sender?.last_name)}
                </p>
                {/* <p className="ps-1">{item?.obj?.sender?.last_name}</p>
                <span className="text-dark-grey">,</span>&nbsp;
                <p>{item?.obj?.sender?.first_name}</p> */}
              </div>
            ) : (
              <div className="d-flex align-items-center">
                <UserChatBubble
                  userId={item?.obj?.sender?.id}
                  first_name={item?.obj?.sender?.first_name || ""}
                  last_name={item?.obj?.sender?.last_name || ""}
                  profilePic={item?.obj?.sender?.profile_pic ?? ""}
                  isActive={userOnlineStatus?.[item?.obj?.sender?.id]?.isOnline ?? false}
                  is_active={item?.obj?.sender?.is_active}
                  width={19}
                />
              </div>
            )}
          </>
        );
      }
      return sender;
    }
    if (item.type === "PhoneCall" || item.type === "LetterTemplateLog") {
      return (
        <>
          {item?.user?.user_type === "Client" ? (
            <div className="d-flex align-items-center">
              <div
                className="image-container-modal"
                style={{
                  width: "19px",
                  height: "19px",
                }}
              >
                <img
                  src={item?.user?.profile_pic ?? avatarImage}
                  // alt={avatar}
                  style={{
                    width: "19px",
                    height: "19px",
                    background: "var(--primary-30)",
                  }}
                />
                {/* <div className="border-overlay-modal" /> */}
              </div>
              {/* <p className="ps-1">{item?.user?.last_name}</p>
              <span className="text-dark-grey">,</span>&nbsp;
              <p>{item?.user?.first_name}</p> */}
              <p className="ps-1">
                {getDisplayName(item?.user?.first_name, item?.user?.last_name)}
              </p>
            </div>
          ) : (
            <div className="d-flex align-items-center">
              <UserChatBubble
                userId={item?.user?.id}
                first_name={item?.user?.first_name || ""}
                last_name={item?.user?.last_name || ""}
                profilePic={item?.user?.profile_pic ?? ""}
                isActive={userOnlineStatus?.[item?.user?.id]?.isOnline ?? false}
                is_active={item?.user?.is_active}
                width={19}
              />
            </div>
          )}
        </>
      );
    }
    if (item?.type === "OutboundRecordedCall") {
      console.log(item);
      return (
        <>
          <div className="d-flex align-items-center">
            <UserChatBubble
              userId={item?.obj?.initiated_by?.id}
              first_name={item?.obj?.initiated_by?.first_name || ""}
              last_name={item?.obj?.initiated_by?.last_name || ""}
              profilePic={item?.obj?.initiated_by?.profile_pic ?? ""}
              isActive={userOnlineStatus?.[item?.obj?.initiated_by?.id]?.isOnline ?? false}
              is_active={item?.obj?.initiated_by?.is_active}
              width={19}
            />
          </div>
        </>
      );
    }
    if (item?.type === "InboundRecordedCall") {
      console.log(item);
      return (
        <>
          <div className="d-flex align-items-center">
            {item?.obj?.initiated_by && (
              <div className="d-flex align-items-center">
                <div
                  className="image-container-modal d-flex align-items-center justify-content-center"
                  style={{
                    width: "15px",
                    height: "15px",
                  }}
                >
                  <img
                    src={item?.obj?.initiated_by?.profile_pic_19p ?? avatarImage}
                    // alt={avatar}
                    style={{
                      width: "15px",
                      height: "15px",
                      background: "var(--primary-30)",
                    }}
                  />
                  {/* <div className="border-overlay-modal" /> */}
                </div>
                <p className="ps-1">
                  {getDisplayName(
                    item?.obj?.initiated_by?.first_name,
                    item?.obj?.initiated_by?.last_name
                  )}
                </p>

                {/* <p className="ps-1">{item?.sent_by_user?.last_name}</p>
              <span className="text-dark-grey">,</span>&nbsp;
              <p>{item?.sent_by_user?.first_name}</p> */}
              </div>
            )}
            {/* <UserChatBubble
              first_name={item?.obj?.initiated_by?.first_name || ""}
              last_name={item?.obj?.initiated_by?.last_name || ""}
              profilePic={item?.obj?.initiated_by?.profile_pic ?? ""}
              isActive={userOnlineStatus?.[item?.obj?.initiated_by?.id]?.isOnline ?? false}
              is_active={item?.obj?.initiated_by?.is_active}
              width={19}
            /> */}
          </div>
        </>
      );
    }

    return "";
  };

  // Helper to get message/note content
  const getMessageContent = (item) => {
    console.log(item);
    if (item.comm_type === "Email" || item.type === "Email") {
      return item.body;
    }
    if (item.type === "ChatMessage") {
      return item.obj?.content;
    }
    if (item.type === "TextMessage" || item.type === "IncomingTextMessage") {
      return item.obj?.body;
    }
    if (item.type === "PhoneCall" || item.type === "LetterTemplateLog") {
      return item.description;
    }
    if (item.type === "OutboundRecordedCall" || item.type === "InboundRecordedCall") {
      return item.obj?.final_message;
    }
    return "";
  };

  // Group items by date
  const groupByDate = (items) => {
    return items.reduce((acc, item) => {
      const dateKey = getDateKey(item);
      if (!dateKey) return acc;
      if (!acc[dateKey]) acc[dateKey] = [];
      acc[dateKey].push(item);
      return acc;
    }, {});
  };

  // Calculate fake rows needed
  const calculateFakeRows = (items, minRows = 8) => {
    // const grouped = groupByDate(items);
    // const dateHeaderCount = Object.keys(grouped).length;
    const itemCount = items.length;
    const totalRows = itemCount;
    return Math.max(0, minRows - totalRows);
  };

  // Handle document preview for letters
  const handleDocPreview = (letterItem) => {
    if (letterItem.id) {
      showDocumentModal("document", letterItem.upload, letterItem);
    }
  };

  // Handle opening draft in word processor
  const handleOpenDraft = async (draftId, docId, dynamicTemplateId, documentName) => {
    try {
      // Check draft lock status
      const lockResponse = await axios.post(
        `${origin}/api/documents/check-draft-lock/`,
        { draft_id: draftId },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (lockResponse.data.error) {
        alert("Unable to check draft status. Please try again.");
        return;
      }

      if (lockResponse.data.is_locked) {
        const lockedBy = lockResponse.data.locked_by;
        const lockedByName = lockedBy
          ? `${lockedBy.first_name} ${lockedBy.last_name}`
          : "another user";
        alert(
          `This draft is currently being edited by ${lockedByName}. It will be available when they close the document.`
        );
        return;
      }

      // Construct the word processor URL
      const isProduction = process.env.NODE_ENV === "production";
      const newBaseUrl = isProduction
        ? `/bp-wordprocessor/${clientId}/${caseId}`
        : `/bp-wordprocessor/${clientId}/${caseId}`;
      const url = `${newBaseUrl}/?docId=${docId}&type=Draft&dynamic_template_id=${dynamicTemplateId}&draftId=${draftId}`;

      // Add redirect URL for navigation back
      const currentUrl = window.location.href;
      const encodedRedirectUrl = encodeURIComponent(currentUrl || "");
      const finalUrl = `${url}&redirect_url=${encodedRedirectUrl}`;

      // Create edit doc record
      const formData = new FormData();
      formData.append("doc_id", docId);
      formData.append("url", finalUrl);
      formData.append("redirect_url", currentUrl);
      formData.append("name", documentName || "Document");
      formData.append("template_id", dynamicTemplateId);
      formData.append("from_page", 2); // Client page ID

      await axios.post(`${origin}/api/create-edit-doc/`, formData, {
        headers: {
          Authorization: token,
        },
      });

      // Navigate to the word processor
      window.location.href = finalUrl;
    } catch (error) {
      console.error("Error opening draft:", error);
      alert("Failed to open draft. Please try again.");
    }
  };

  let rowIndex = 0;
  let textIndex = 0;
  let emailIndex = 0;
  let letterIndex = 0;
  let phoneCallIndex = 0;
  let CallIndex = 0;

  const adjustCaseDetailsWidths = () => {
    const tableWidth = document.querySelectorAll(".table-width-full-size");
    const dateCol = document.querySelectorAll(".date-comm-tab-col");
    const timeCol = document.querySelectorAll(".time-comm-tab-col");
    const fromCol = document.querySelectorAll(".from-comm-tab-col");
    // const msgCol = document.querySelectorAll(".msg-comm-tab-col");
    let tableWidth2 = 0;
    let maxDateColW = 100;
    let maxTimeColW = 75;
    let maxFromColW = 180;
    // let msgColW = 0;

    tableWidth.forEach((column) => {
      const width = column.getBoundingClientRect().width;
      tableWidth2 = Math.max(tableWidth2, width);
    });
    dateCol.forEach((column) => {
      const width = column.getBoundingClientRect().width;
      maxDateColW = Math.max(maxDateColW, width);
    });

    dateCol.forEach((column) => {
      column.style.width = `${maxDateColW}px`;
      column.style.minWidth = `${maxDateColW}px`;
      column.style.maxWidth = `${maxDateColW}px`;
    });

    timeCol.forEach((column) => {
      const width = column.getBoundingClientRect().width;
      maxTimeColW = Math.max(maxTimeColW, width);
    });

    timeCol.forEach((column) => {
      column.style.width = `${maxTimeColW}px`;
      column.style.minWidth = `${maxTimeColW}px`;
      column.style.maxWidth = `${maxTimeColW}px`;
    });

    fromCol.forEach((column) => {
      const width = column.getBoundingClientRect().width;
      maxFromColW = Math.max(maxFromColW, width);
    });

    fromCol.forEach((column) => {
      column.style.width = `${maxFromColW}px`;
      column.style.minWidth = `${maxFromColW}px`;
      column.style.maxWidth = `${maxFromColW}px`;
    });

    // msgCol.forEach((column) => {
    //   const width = column.getBoundingClientRect().width;
    //   msgColW = Math.max(msgColW, width);
    // });
    // console.log(msgColW);

    // msgCol.forEach((column) => {
    //   column.style.width = `${msgColW}px`;
    //   column.style.minWidth = `${msgColW}px`;
    //   column.style.maxWidth = `${msgColW}px`;
    // });
  };

  useEffect(() => {
    adjustCaseDetailsWidths();
    window.addEventListener("resize", adjustCaseDetailsWidths);
    return () => {
      window.removeEventListener("resize", adjustCaseDetailsWidths);
    };
  }, [all]);

  useEffect(() => {
    if (clientId && token) {
      fetchUnreadCount();
    }
  }, [clientId, token]);

  const [selectedCall, setSelectedCall] = useState(null);
  const [transcriptionModal, setTranscriptionModal] = useState(false);
  const [playingId, setPlayingId] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const audioRef = useRef(null);
  const [recordingModalOpen, setRecordingModalOpen] = useState(false);
  const [selectedRecordingCall, setSelectedRecordingCall] = useState(null);
  const handlePhoneRecordingPlay = async (data) => {
    if (playingId === data?.call_id) {
      audioRef.current?.pause();
      setPlayingId(null);
      return;
    }

    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }
    if (audioUrl) URL.revokeObjectURL(audioUrl);

    setPlayingId(data?.call_id);

    try {
      const response = await api_without_cancellation.get(
        `/api/client-page/client-communication/calls/${data?.call_id}/recording/`,
        { responseType: "arraybuffer" }
      );
      const blob = new Blob([response.data], { type: "audio/wav" });
      const url = URL.createObjectURL(blob);
      setAudioUrl(url);

      const audio = new Audio(url);
      audioRef.current = audio;
      audio.play();

      audio.onended = () => setPlayingId(null);
    } catch (error) {
      console.error(error);
      setPlayingId(null);
    }
  };

  const fetchRecording = async (callId) => {
    const response = await api_without_cancellation.get(
      `/api/client-page/client-communication/calls/${callId}/recording/`,
      { responseType: "arraybuffer" }
    );
    return response;
  };
  // const adjustCallWidth = () => {
  //   const leftColumns = document.querySelectorAll(".call-index-name");

  //   let maxLeftWidth = 0;

  //   // Calculate maximum width for left and right columns
  //   leftColumns.forEach((column) => {
  //     const width = column.getBoundingClientRect().width;
  //     maxLeftWidth = Math.max(maxLeftWidth, width);
  //   });

  //   leftColumns.forEach((column) => {
  //     column.style.width = `${maxLeftWidth}px`;
  //   });
  // };

  // useEffect(() => {
  //   adjustCallWidth();
  //   window.addEventListener("resize", adjustCallWidth);
  //   return () => {
  //     window.removeEventListener("resize", adjustCallWidth);
  //   };
  // }, [call]);

  const defaultThumbnailProps = {
    height: "349px",
    width: "255px",
    borderColor: "var(--primary-15)",
  };
  const [showCommunicationModal, setShowCommunicationModal] = useState(false);
  const communicationTabs = useMemo(() => {
    const tabs = [
      {
        id: "all",
        label: "All",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => {
          addClickRecord(121, 2);
          setActiveTab("all");
          loadTabInitial("all");
        },
      },
      {
        id: "chat",
        label: "Chat",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => {
          addClickRecord(122, 2);
          setActiveTab("chat");
          loadTabInitial("chat");
        },
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
              // scale: "1.4",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <img
              src={ChatIcon}
              style={{
                width: "15px",
                height: "15px",
                scale: "1.8",
              }}
              alt="Detail"
            />
          </span>
        ),
      },
      {
        id: "text",
        label: "Text",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => {
          addClickRecord(123, 2);
          setActiveTab("text");
          loadTabInitial("text");
        },
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <i className="ic ic-15 ic-sms-3d" />
          </span>
        ),
      },
      {
        id: "email",
        label: "Email",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => {
          addClickRecord(124, 2);
          setActiveTab("email");
          loadTabInitial("email");
        },
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <i className="ic ic-15 ic-email-3d" />
            {unreadEmailCount > 0 && (
              <span className="badge text-bg-danger ms-1">{unreadEmailCount}</span>
            )}
          </span>
        ),
      },

      {
        id: "phone_call",
        label: "Phone",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => {
          addClickRecord(126, 2);
          setActiveTab("phone_call");
          loadTabInitial("phone_call");
        },
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <NewPhoneIcon />
          </span>
        ),
      },
      {
        id: "letter",
        label: "Letter",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => {
          addClickRecord(125, 2);
          setActiveTab("letter");
          loadTabInitial("letter");
        },
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <i className="ic ic-15 ic-file-colored" />
          </span>
        ),
      },
    ];

    return tabs;
  }, [unreadEmailCount]);

  const communicationActionTabs = useMemo(() => {
    const tabs = [];

    tabs.push({
      id: "communication-action",
      label:
        activeTab === "all"
          ? "Communication"
          : activeTab === "chat"
            ? "Chat"
            : activeTab === "text"
              ? "Text"
              : activeTab === "email"
                ? `Send Email to ${clientData?.client?.first_name} ${clientData?.client?.last_name}`
                : activeTab === "letter"
                  ? "Letter"
                  : "Phone Call",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",
      leftHand: true,
      onClick: () => {
        addClickRecord(999, 2);

        if (activeTab === "all") {
          setShowCommunicationModal(true);
        } else {
          handleAddClick();
        }
      },
      span: (
        <span className="fw-bold  ic-15 d-flex align-items-center">
          <img className="d-flex align-items-center justify-content-center" src={AddIcon} />
        </span>
      ),
    });

    return tabs;
  }, [activeTab, clientData]);

  const isUnread = (item) => {
    if (item.comm_type === "Email") {
      // For emails, we keep the old is_read logic, but can also use is_reviewed
      // For consistency, we'll use is_reviewed if present, else fallback to is_read
      if (item.is_reviewed !== undefined) return !item.is_reviewed;
      return !item.is_read;
    }
    // For all other types, check is_reviewed on the object
    if (item.obj && item.obj.is_reviewed !== undefined) return !item.obj.is_reviewed;
    // If not present, assume reviewed (or we can default to false)
    return false;
  };
  return (
    <>
      <div
        className="d-flex m-b-5"
        style={{
          gap: "5px",
        }}
      >
        {clientData?.processed_photo_slots
          ? clientData.processed_photo_slots.map((photoSlot, index) => {
              if (!photoSlot?.photo) {
                return (
                  <DefaultThumbnail
                    key={`empty-${index}`}
                    {...defaultThumbnailProps}
                    photoData={photoSlot}
                    photoSlots={clientData?.processed_photo_slots}
                    pageName="Client"
                    refetch={refetch}
                  />
                );
              }
              return (
                <PhotoSlot
                  key={photoSlot.photo?.photo_slot.slot_number}
                  photoSlot={photoSlot?.photo}
                  photoSlots={clientData?.processed_photo_slots}
                  pageName="Client"
                  slotNumber={photoSlot.photo?.photo_slot.slot_number}
                  height="349"
                  width="255"
                  refetch={refetch}
                />
              );
            })
          : Array.from({ length: 1 }).map((_, index) => (
              <DefaultThumbnail
                key={`skeleton-${index}`}
                {...defaultThumbnailProps}
                photoData={null}
              />
            ))}
        <Tab.Container defaultActiveKey={activeTab} activeKey={activeTab}>
          <div
            style={{
              width: "calc(100% - 260px)",
            }}
          >
            <SmartResponsiveTabsContainer
              HandlePage={activeTab}
              tabsData={communicationTabs}
              viewTab={[]}
              addTab={communicationActionTabs}
              photoTab={[]}
              viewType={""}
            />

            <Tab.Content className="table-width-full-size">
              {/* ALL TAB */}
              <Tab.Pane eventKey="all">
                <div
                  className="table--no-card rounded-0 border-0"
                  style={{
                    scrollbarWidth: "none",
                    overflowY: "scroll",
                    maxHeight: "324px",
                  }}
                >
                  <table className="table table-borderless table-earning">
                    <thead className="sticked-head" style={{}}>
                      <tr id="tb-header">
                        <th
                          className=""
                          style={{ width: "25px", minWidth: "25px", maxWidth: "25px" }}
                        />
                        <th className="td-autosize text-center date-comm-tab-col">Date</th>
                        <th className="td-autosize text-center time-comm-tab-col">Time</th>

                        <th className="td-autosize text-center from-comm-tab-col">From</th>
                        <th
                          className=" text-center"
                          style={{ width: "25px", minWidth: "25px", maxWidth: "25px" }}
                        />
                        {/* <th className="td-autosize text-center" style={{ width: "255px" }} /> */}
                        <th
                          className="text-center msg-comm-tab-col"
                          colSpan={2}
                          style={{ position: "relative" }}
                        >
                          Message
                          <PaginationWidget tabKey="all" />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {all.length > 0 &&
                        Object.entries(groupByDate(all))?.map(([date, items]) => (
                          <React.Fragment key={date}>
                            {items?.map((item, index) => {
                              const itemType = item.comm_type || item.type;
                              const unread = isUnread(item);
                              rowIndex += 1;
                              return (
                                <tr
                                  key={`${itemType}-${item.id || item.obj?.id || index}`}
                                  style={{
                                    color: unread ? "black" : "var(--primary-80)",
                                    fontWeight: unread ? 700 : 400,
                                    cursor:
                                      itemType !== "LetterTemplateLog" &&
                                      itemType !== "OutboundRecordedCall" &&
                                      itemType !== "InboundRecordedCall"
                                        ? "pointer"
                                        : "default",
                                  }}
                                  onClick={() => {
                                    addClickRecord(999, 2);
                                    if (itemType !== "Email") {
                                      markItemAsReviewed(item);
                                    }
                                    if (itemType === "ChatMessage") {
                                      setShowChatModal(true);
                                    } else if (
                                      itemType === "TextMessage" ||
                                      itemType === "IncomingTextMessage"
                                    ) {
                                      handleTextMessageClick(item);
                                    } else if (itemType === "Email") {
                                      handleEmailMessageClick(item);
                                    } else if (itemType === "PhoneCall") {
                                      setShowPhoneCallModal(true);
                                    }
                                    // LetterTemplateLog and OutboundRecordedCall have inline buttons
                                  }}
                                >
                                  <td id="client-comm-date-sep">{rowIndex}</td>
                                  <td
                                    className="text-end"
                                    // id="client-comm-date-sep"
                                  >
                                    {new Date(date).toLocaleDateString("en-US", {
                                      month: "short",
                                      day: "numeric",
                                      year: "numeric",
                                    })}
                                  </td>
                                  <td className="white-space-nowrap text-end">
                                    {/* <b className="text-transform-font-weight text-end"> */}
                                    {new Date(getDateTime(item))
                                      .toLocaleTimeString("en-US", {
                                        hour: "numeric",
                                        minute: "2-digit",
                                        hour12: true,
                                      })
                                      .toLowerCase()}
                                    {/* </b> */}
                                  </td>

                                  <td className=" text-start">{getFromValue(item)}</td>
                                  <td className="text-center justify-content-center">
                                    {itemType === "ChatMessage" && (
                                      <span className="d-flex align-items-center justify-content-center">
                                        <img
                                          src={ChatIcon}
                                          className=""
                                          style={{
                                            width: "15px",
                                            height: "15px",
                                            scale: "1.7",
                                          }}
                                          // width="19"
                                          alt="Chat"
                                        />
                                      </span>
                                    )}
                                    {["TextMessage", "IncomingTextMessage"].includes(itemType) && (
                                      <span className="d-flex align-items-center justify-content-center">
                                        <i
                                          className="ic ic-15 ic-sms-3d"
                                          style={{
                                            width: "15px",
                                            height: "15px",
                                          }}
                                        />
                                      </span>
                                    )}
                                    {itemType === "Email" && (
                                      <span className="d-flex align-items-center justify-content-center">
                                        <i
                                          className="ic ic-15 ic-email-3d"
                                          style={{
                                            width: "15px",
                                            height: "15px",
                                          }}
                                        />
                                      </span>
                                    )}
                                    {itemType === "LetterTemplateLog" && (
                                      <span className="d-flex align-items-center justify-content-center">
                                        <i
                                          className="ic ic-15 ic-file-colored"
                                          style={{
                                            width: "15px",
                                            height: "15px",
                                          }}
                                        />
                                      </span>
                                    )}
                                    {itemType === "PhoneCall" && (
                                      <span className="d-flex align-items-center justify-content-center">
                                        <NewPhoneIcon />
                                      </span>
                                    )}
                                    {itemType === "OutboundRecordedCall" && (
                                      <span className="d-flex align-items-center justify-content-center">
                                        {item.obj?.status === "no_answer" ? (
                                          <NewRejectedIcon />
                                        ) : (
                                          <NewPhoneIcon />
                                        )}
                                      </span>
                                    )}
                                    {itemType === "InboundRecordedCall" && (
                                      <span className="d-flex align-items-center justify-content-center">
                                        {item.obj?.status === "no_answer" ? (
                                          <NewRejectedIcon />
                                        ) : (
                                          <NewPhoneIcon />
                                        )}
                                      </span>
                                    )}
                                  </td>
                                  <td className="text-start">
                                    {/* Type-specific column */}
                                    {itemType === "ChatMessage" && (
                                      <span className="">
                                        {getMessageContent(item)?.slice(0, 300)}
                                      </span>
                                    )}
                                    {itemType === "TextMessage" && (
                                      <span className="">
                                        {getMessageContent(item)?.slice(0, 300)}
                                      </span>
                                    )}
                                    {itemType === "IncomingTextMessage" && (
                                      <span className="">
                                        {getMessageContent(item)?.slice(0, 300)}
                                      </span>
                                    )}
                                    {(itemType === "Email" || item.comm_type === "Email") && (
                                      <span
                                        className=" white-space-text-overflow"
                                        style={{
                                          fontWeight:
                                            item?.from_user === "client" && !item.is_read
                                              ? "bold"
                                              : "normal",
                                          maxHeight: "100px",
                                        }}
                                      >
                                        {item.subject}:{" "}
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(
                                              getMessageContent(item) || ""
                                            ),
                                          }}
                                          style={{
                                            width: "100%",
                                            maxHeight: "79px",
                                            overflow: "hidden",
                                            pointerEvents: "none",
                                          }}
                                        />
                                      </span>
                                    )}
                                    {itemType === "PhoneCall" && (
                                      <span className="">
                                        {formatPhoneNumber
                                          ? formatPhoneNumber(item?.contact_id?.phone_number)
                                          : item?.contact_id?.phone_number}
                                        :{" "}
                                        <span className="">
                                          {getMessageContent(item)?.slice(0, 300)}
                                        </span>
                                      </span>
                                    )}
                                    {itemType === "OutboundRecordedCall" && (
                                      <div
                                        className="d-flex align-items-center justify-content-between "
                                        style={{
                                          gap: "5px",
                                        }}
                                      >
                                        <span className=" call-index-name">
                                          {formatPhoneNumber3
                                            ? formatPhoneNumber3(item?.obj?.client_phone_number)
                                            : item?.obj?.client_phone_number}
                                          :{" "}
                                          <span className=" ">
                                            {getMessageContent(item)?.slice(0, 300)}
                                          </span>
                                        </span>
                                        <div
                                          className="d-flex align-items-center justify-content-center"
                                          style={{
                                            gap: "5px",
                                          }}
                                        >
                                          <button
                                            className="btn btn-secondary height-25  d-flex align-items-center justify-content-center"
                                            style={{
                                              border: "none",
                                              gap: "5px",
                                              padding: "0px 5px",
                                              width: "max-content",
                                              // background: "var(--primary-25)",
                                              // minWidth: "35px",
                                            }}
                                            onClick={() => {
                                              setSelectedCall(item?.obj);
                                              setTranscriptionModal(true);
                                            }}
                                            disabled={!item?.obj?.transcript_available}
                                            title="Transcript Preview"
                                          >
                                            <img
                                              src={transcptionIcon}
                                              style={{
                                                position: "relative",
                                                left: "1px",
                                              }}
                                              className="ic ic-15 d-flex align-items-center justify-content-center"
                                            />
                                            <span className="comm-btn-text">Transcript</span>
                                          </button>
                                          <button
                                            className="btn btn-secondary height-25  d-flex align-items-center justify-content-center"
                                            style={{
                                              border: "none",
                                              gap: "5px",
                                              padding: "0px 5px",
                                              width: "max-content",
                                              // background: "var(--primary-25)",
                                              // minWidth: "35px",
                                            }}
                                            // onClick={() => {
                                            //   handlePhoneRecordingPlay(item?.obj);
                                            // }}
                                            onClick={() => {
                                              setSelectedRecordingCall(item?.obj);
                                              setRecordingModalOpen(true);
                                            }}
                                            disabled={!item?.obj?.recording_available}
                                            title="Recording Available"
                                          >
                                            <img
                                              src={phoneRecordIcon}
                                              className="ic ic-15 d-flex align-items-center justify-content-center"
                                            />
                                            <span className="comm-btn-text">Recording</span>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                    {itemType === "InboundRecordedCall" && (
                                      <div
                                        className="d-flex align-items-center justify-content-between "
                                        style={{
                                          gap: "5px",
                                        }}
                                      >
                                        <span className=" call-index-name">
                                          {formatPhoneNumber3
                                            ? formatPhoneNumber3(item?.obj?.client_phone_number)
                                            : item?.obj?.client_phone_number}
                                          :{" "}
                                          <span className=" ">
                                            {getMessageContent(item)?.slice(0, 300)}
                                          </span>
                                        </span>
                                        <div
                                          className="d-flex align-items-center justify-content-center"
                                          style={{
                                            gap: "5px",
                                          }}
                                        >
                                          <button
                                            className="btn btn-secondary height-25  d-flex align-items-center justify-content-center"
                                            style={{
                                              border: "none",
                                              gap: "5px",
                                              padding: "0px 5px",
                                              width: "max-content",
                                              // background: "var(--primary-25)",
                                              // minWidth: "35px",
                                            }}
                                            onClick={() => {
                                              setSelectedCall(item?.obj);
                                              setTranscriptionModal(true);
                                            }}
                                            disabled={!item?.obj?.transcript_available}
                                            title="Transcript Preview"
                                          >
                                            <img
                                              src={transcptionIcon}
                                              style={{
                                                position: "relative",
                                                left: "1px",
                                              }}
                                              className="ic ic-15 d-flex align-items-center justify-content-center"
                                            />
                                            <span className="comm-btn-text">Transcript</span>
                                          </button>
                                          <button
                                            className="btn btn-secondary height-25  d-flex align-items-center justify-content-center"
                                            style={{
                                              border: "none",
                                              gap: "5px",
                                              padding: "0px 5px",
                                              width: "max-content",
                                              // background: "var(--primary-25)",
                                              // minWidth: "35px",
                                            }}
                                            // onClick={() => {
                                            //   handlePhoneRecordingPlay(item?.obj);
                                            // }}
                                            onClick={() => {
                                              setSelectedRecordingCall(item?.obj);
                                              setRecordingModalOpen(true);
                                            }}
                                            disabled={!item?.obj?.recording_available}
                                            title="Recording Available"
                                          >
                                            <img
                                              src={phoneRecordIcon}
                                              className="ic ic-15 d-flex align-items-center justify-content-center"
                                            />
                                            <span className="comm-btn-text">Recording</span>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                    {itemType === "LetterTemplateLog" && (
                                      <div
                                        className="d-flex align-items-center"
                                        style={{
                                          gap: "5px",
                                        }}
                                      >
                                        {/* Check if this is a PDF (ends with .pdf) */}
                                        {item?.obj?.upload?.toLowerCase().endsWith(".pdf") ? (
                                          <>
                                            {/* PDF Button */}
                                            <button
                                              className="btn height-25 p-0 d-flex align-items-center justify-content-center"
                                              style={{
                                                border: "none",
                                                // padding: "0px 10px",
                                                // background: "var(--primary-25)",
                                                // minWidth: "35px",
                                              }}
                                              onClick={() => {
                                                addClickRecord(999, 2);
                                                handleDocPreview(item?.obj);
                                              }}
                                              title="Open PDF in a new tab"
                                            >
                                              <i className="ic ic-15 ic-generate-document-pdf" />
                                            </button>
                                            {/* Description */}
                                            <span className=" m-r-5">{item?.name}</span>
                                            <span className="">
                                              {getMessageContent(item)?.slice(0, 300)}
                                            </span>
                                            {/* Draft Button - Only show if from_draft exists */}
                                            {item?.obj?.from_draft && (
                                              <button
                                                className="btn height-25 p-0 d-flex align-items-center justify-content-center"
                                                style={{
                                                  border: "none",
                                                  // padding: "0px 10px",
                                                  // background: "var(--primary-25)",
                                                  // minWidth: "35px",
                                                }}
                                                onClick={() => {
                                                  addClickRecord(999, 2);
                                                  handleOpenDraft(
                                                    item?.obj?.from_draft?.id,
                                                    item?.obj?.from_draft?.template?.id,
                                                    item?.obj?.from_draft?.for_template,
                                                    item?.obj?.from_draft?.name
                                                  );
                                                }}
                                                title="Open draft in word processor"
                                              >
                                                <img
                                                  src={DraftsLogo}
                                                  alt="Draft"
                                                  style={{
                                                    width: "15px",
                                                    height: "15px",
                                                  }}
                                                />
                                              </button>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {/* Original letter display for non-PDF drafts */}
                                            {item?.doc_id !== null && (
                                              <div className="icon-text-boxes d-flex flex-wrap w-100 e-template-row height-25">
                                                <div
                                                  className="col-12 col-md-3 col-xl icon-text-box text-center height-25 font-weight-semibold cursor-pointer btn-hover-document-row"
                                                  id="no-vertical-border"
                                                  style={{
                                                    borderColor: "var(--primary)",
                                                    backgroundColor: "var(--primary-10)",
                                                    color: "var(--primary)",
                                                    border: "1px solid var(--primary)",
                                                    maxWidth: "255px",
                                                  }}
                                                  onClick={() => {
                                                    addClickRecord(999, 2);
                                                    handleOpenDraft(
                                                      item?.obj?.draft_itself?.id,
                                                      item?.obj?.id,
                                                      item?.obj?.draft_itself?.for_template,
                                                      item?.obj?.draft_itself?.name
                                                    );
                                                  }}
                                                >
                                                  <p className="date">{item?.obj?.created}</p>
                                                  <span
                                                    className="icon-wrap"
                                                    style={{
                                                      height: "15px",
                                                      width: "15px",
                                                      maxWidth: "15px",
                                                      flex: "0 0 15px",
                                                      margin: 0,
                                                    }}
                                                  >
                                                    <i className="ic ic-15 ic-file-colored cursor-pointer" />
                                                  </span>
                                                  <p className="name">{item?.obj?.file_name}</p>
                                                </div>
                                              </div>
                                            )}
                                            <span className=" m-r-5">{item?.name}</span>
                                            <span className="">
                                              {getMessageContent(item)?.slice(0, 300)}
                                            </span>
                                          </>
                                        )}
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </React.Fragment>
                        ))}
                      {[...Array(Math.max(0, 9 - all.length))]?.map((_, index) => (
                        <tr
                          key={`fake-row-${index}`}
                          className="fake-row-2"
                          style={{ height: "35px" }}
                        >
                          <td colSpan="7">&nbsp;</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Tab.Pane>

              {/* CHAT TAB */}
              <Tab.Pane eventKey="chat">
                <div
                  className="table--no-card rounded-0 border-0 "
                  style={{
                    scrollbarWidth: "none",
                    overflowY: "scroll",
                    maxHeight: "324px",
                  }}
                >
                  <table className="table table-borderless table-earning">
                    <thead className="sticked-head" style={{}}>
                      <tr id="tb-header">
                        <th
                          className=""
                          style={{ width: "25px", minWidth: "25px", maxWidth: "25px" }}
                        />
                        <th className=" text-center date-comm-tab-col">Date</th>
                        <th className=" text-center time-comm-tab-col">Time</th>
                        <th className=" text-center from-comm-tab-col">From</th>
                        <th
                          className=" text-center"
                          style={{ width: "25px", minWidth: "25px", maxWidth: "25px" }}
                        />
                        <th
                          className="text-center msg-comm-tab-col"
                          style={{ position: "relative" }}
                        >
                          Message
                          <PaginationWidget tabKey="chat" />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {chat.length > 0 &&
                        chat?.map((message, index) => (
                          <tr
                            style={{
                              color: "var(--primary-80)",
                              fontWeight: 400,
                            }}
                            key={message.obj?.id || index}
                            onClick={() => setShowChatModal(true)}
                          >
                            <td id="client-comm-date-sep">{index + 1}</td>
                            <td
                              className="text-end"
                              // id="client-comm-date-sep"
                            >
                              {new Date(message?.obj?.timestamp).toLocaleDateString("en-US", {
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                              })}
                            </td>
                            <td className="white-space-nowrap text-end">
                              {/* <b className="text-transform-font-weight"> */}
                              {new Date(getDateTime(message))
                                .toLocaleTimeString("en-US", {
                                  hour: "numeric",
                                  minute: "2-digit",
                                  hour12: true,
                                })
                                .toLowerCase()}
                              {/* </b> */}
                            </td>
                            <td className=" d-flex align-items-center">
                              {message?.obj?.user?.user_type === "Client" ? (
                                <div className="d-flex align-items-center">
                                  <div
                                    className="image-container-modal d-flex align-items-center justify-content-center"
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                    }}
                                  >
                                    <img
                                      src={message?.obj?.user?.profile_pic ?? avatarImage}
                                      // alt={avatar}
                                      style={{
                                        width: "15px",
                                        height: "15px",
                                        background: "var(--primary-30)",
                                      }}
                                    />
                                    {/* <div className="border-overlay-modal" /> */}
                                  </div>
                                  {/* <p className="ps-1">{message?.obj?.user?.last_name}</p>
                                  <span className="text-dark-grey">,</span>&nbsp;
                                  <p>{message?.obj?.user?.first_name}</p> */}
                                  <p className="ps-1">
                                    {getDisplayName(
                                      message?.obj?.user?.first_name,
                                      message?.obj?.user?.last_name
                                    )}
                                  </p>
                                </div>
                              ) : (
                                <div className="d-flex align-items-center">
                                  <UserChatBubble
                                    userId={message?.obj?.user?.id}
                                    first_name={message?.obj?.user?.first_name || ""}
                                    last_name={message?.obj?.user?.last_name || ""}
                                    profilePic={message?.obj?.user?.profile_pic ?? ""}
                                    isActive={
                                      userOnlineStatus?.[message?.obj?.user?.id]?.isOnline ?? false
                                    }
                                    is_active={message?.obj?.user?.is_active}
                                    width={19}
                                  />
                                </div>
                              )}
                            </td>

                            {/* Icon */}
                            <td className="text-center justify-content-center">
                              <span className="d-flex align-items-center justify-content-center">
                                <img
                                  src={ChatIcon}
                                  className=""
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    scale: "1.7",
                                  }}
                                  // width="19"
                                  alt="Chat"
                                />
                              </span>
                            </td>

                            {/* Message Body */}
                            {message?.obj?.content?.length > 300 ? (
                              <td className=" white-space-text-overflow text-start">
                                {message?.obj?.content?.slice(0, 300)}
                              </td>
                            ) : (
                              <td className=" white-space-text-overflow text-start">
                                {message?.obj?.content?.slice(0, 300)}
                              </td>
                            )}
                          </tr>
                        ))}
                      {[...Array(Math.max(0, 8 - chat.length))]?.map((_, index) => (
                        <tr
                          key={`additional-${index}`}
                          className="fake-row-2"
                          style={{ height: "35px" }}
                        >
                          <td colSpan="6">&nbsp;</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Tab.Pane>

              {/* TEXT TAB */}
              <Tab.Pane eventKey="text">
                <div
                  className="table--no-card rounded-0 border-0"
                  style={{
                    scrollbarWidth: "none",
                    overflowY: "scroll",
                    maxHeight: "324px",
                  }}
                >
                  <table className="table table-borderless table-earning">
                    <thead className="sticked-head" style={{}}>
                      <tr id="tb-header">
                        <th
                          className=""
                          style={{ width: "25px", minWidth: "25px", maxWidth: "25px" }}
                        />
                        <th className=" text-center date-comm-tab-col">Date</th>
                        <th className=" text-center time-comm-tab-col">Time</th>
                        <th className=" text-center from-comm-tab-col">From</th>
                        <th
                          className=" text-center"
                          style={{ width: "25px", minWidth: "25px", maxWidth: "25px" }}
                        />
                        <th
                          className="text-center msg-comm-tab-col"
                          style={{ position: "relative" }}
                        >
                          Message
                          <PaginationWidget tabKey="text" />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {text.length > 0 &&
                        Object.entries(
                          text.reduce((acc, message) => {
                            const dateKey = new Date(message.obj?.created_at)
                              .toISOString()
                              .slice(0, 10);
                            if (!acc[dateKey]) acc[dateKey] = [];
                            acc[dateKey].push(message);
                            return acc;
                          }, {})
                        )?.map(([date, messages]) => (
                          <React.Fragment key={date}>
                            {messages?.map((message, index) => {
                              textIndex += 1;
                              const unread = isUnread(message);
                              return (
                                <tr
                                  key={message.obj?.id}
                                  className="client-comm-text-row"
                                  style={{
                                    color: unread ? "black" : "var(--primary-80)",
                                    fontWeight: unread ? 700 : 400,
                                  }}
                                  onClick={() => {
                                    addClickRecord(999, 2);
                                    markItemAsReviewed(message);
                                    handleTextMessageClick(message);
                                  }}
                                >
                                  <td id="client-comm-date-sep">{textIndex}</td>
                                  <td
                                    className="text-end"
                                    // id="client-comm-date-sep"
                                  >
                                    {new Date(date).toLocaleDateString("en-US", {
                                      month: "short",
                                      day: "numeric",
                                      year: "numeric",
                                    })}
                                  </td>
                                  <td className="text-end">
                                    {/* <b className="text-transform-font-weight"> */}
                                    {new Date(message.obj?.created_at)
                                      .toLocaleTimeString("en-US", {
                                        hour: "numeric",
                                        minute: "2-digit",
                                        hour12: true,
                                      })
                                      .toLowerCase()}
                                    {/* </b> */}
                                  </td>
                                  <td className=" d-flex align-items-center">
                                    {message?.obj?.sender?.user_type === "Client" ? (
                                      <div className="d-flex align-items-center">
                                        <div
                                          className="image-container-modal d-flex align-items-center justify-content-center"
                                          style={{
                                            width: "15px",
                                            height: "15px",
                                          }}
                                        >
                                          <img
                                            src={message?.obj?.sender?.profile_pic ?? avatarImage}
                                            // alt={avatar}
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                              background: "var(--primary-30)",
                                            }}
                                          />
                                          {/* <div className="border-overlay-modal" /> */}
                                        </div>
                                        {/* <p className="ps-1">{message?.obj?.sender?.last_name}</p>
                                        <span className="text-dark-grey">,</span>&nbsp;
                                        <p>{message?.obj?.sender?.first_name}</p> */}
                                        <p className="ps-1">
                                          {getDisplayName(
                                            message?.obj?.sender?.first_name,
                                            message?.obj?.sender?.last_name
                                          )}
                                        </p>
                                      </div>
                                    ) : (
                                      <div className="  d-flex align-items-center">
                                        <UserChatBubble
                                          userId={message?.obj?.sender?.id}
                                          first_name={message?.obj?.sender?.first_name}
                                          last_name={message?.obj?.sender?.last_name}
                                          profilePic={message?.obj?.sender?.profile_pic ?? ""}
                                          isActive={
                                            userOnlineStatus?.[message?.obj?.sender?.id]
                                              ?.isOnline ?? false
                                          }
                                          is_active={message?.obj?.sender?.is_active}
                                          width={19}
                                        />
                                      </div>
                                    )}
                                  </td>
                                  <td className="text-center justify-content-center">
                                    <span className="d-flex align-items-center justify-content-center">
                                      <i
                                        className="ic ic-15 ic-sms-3d"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                      />
                                    </span>
                                  </td>
                                  <td className=" white-space-text-overflow text-start">
                                    {message.obj?.body?.slice(0, 300)}
                                  </td>
                                </tr>
                              );
                            })}
                          </React.Fragment>
                        ))}
                      {(() => {
                        const fakeRowsNeeded = calculateFakeRows(text);
                        return [...Array(fakeRowsNeeded)]?.map((_, index) => (
                          <tr
                            key={`fake-row-${index}`}
                            className="fake-row-2"
                            style={{ height: "35px" }}
                          >
                            <td colSpan="6">&nbsp;</td>
                          </tr>
                        ));
                      })()}
                    </tbody>
                  </table>
                </div>
              </Tab.Pane>

              {/* EMAIL TAB */}
              <Tab.Pane eventKey="email">
                <div
                  className="table--no-card rounded-0 border-0 "
                  style={{
                    scrollbarWidth: "none",
                    overflowY: "scroll",
                    maxHeight: "324px",
                  }}
                >
                  <table className="table table-borderless table-earning">
                    <thead className="sticked-head" style={{}}>
                      <tr id="tb-header">
                        <th
                          className=""
                          style={{ width: "25px", minWidth: "25px", maxWidth: "25px" }}
                        />
                        <th className=" text-center date-comm-tab-col">Date</th>
                        <th className=" text-center time-comm-tab-col">Time</th>
                        <th className=" text-center from-comm-tab-col">From</th>
                        <th
                          className=" text-center"
                          style={{ width: "25px", minWidth: "25px", maxWidth: "25px" }}
                        />
                        <th
                          className="text-center msg-comm-tab-col"
                          style={{ position: "relative" }}
                        >
                          Message
                          <PaginationWidget tabKey="email" />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {email.length > 0 &&
                        Object.entries(
                          email.reduce((acc, emailItem) => {
                            const dateKey = new Date(emailItem.date_received)
                              .toISOString()
                              .slice(0, 10);
                            if (!acc[dateKey]) acc[dateKey] = [];
                            acc[dateKey].push(emailItem);
                            return acc;
                          }, {})
                        )?.map(([date, emails]) => (
                          <React.Fragment key={date}>
                            {emails?.map((emailItem, index) => {
                              emailIndex += 1;
                              const unread =
                                emailItem?.from_user === "client" && !emailItem.is_read;
                              return (
                                <tr
                                  key={emailItem.id || `${date}-${index}`}
                                  onClick={() => {
                                    addClickRecord(999, 2);
                                    handleEmailMessageClick(emailItem);
                                  }}
                                  style={{
                                    color: unread ? "black" : "var(--primary-80)",
                                    fontWeight: unread ? 700 : 400,
                                  }}
                                >
                                  <td id="client-comm-date-sep">{emailIndex}</td>
                                  <td
                                    className="text-end"
                                    // id="client-comm-date-sep"
                                  >
                                    {new Date(date).toLocaleDateString("en-US", {
                                      month: "short",
                                      day: "numeric",
                                      year: "numeric",
                                    })}
                                  </td>
                                  <td className="text-end">
                                    {/* <b className="text-transform-font-weight"> */}
                                    {new Date(emailItem.date_received)
                                      .toLocaleTimeString("en-US", {
                                        hour: "numeric",
                                        minute: "2-digit",
                                        hour12: true,
                                      })
                                      .toLowerCase()}
                                    {/* </b> */}
                                  </td>
                                  {/* <td className="text-black text-start">{emailItem.sender}</td> */}
                                  <td className="">
                                    {emailItem?.sent_by_user?.user_type === "Client" ? (
                                      <div className="d-flex align-items-center">
                                        <div
                                          className="image-container-modal d-flex align-items-center justify-content-center"
                                          style={{
                                            width: "15px",
                                            height: "15px",
                                          }}
                                        >
                                          <img
                                            src={
                                              emailItem?.sent_by_user?.profile_pic ?? avatarImage
                                            }
                                            // alt={avatar}
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                              background: "var(--primary-30)",
                                            }}
                                          />
                                          {/* <div className="border-overlay-modal" /> */}
                                        </div>
                                        {/* <p className="ps-1">{emailItem?.sent_by_user?.last_name}</p>
                                        <span className="text-dark-grey">,</span>&nbsp;
                                        <p>{emailItem?.sent_by_user?.first_name}</p> */}
                                        <p className="ps-1">
                                          {getDisplayName(
                                            emailItem?.sent_by_user?.first_name,
                                            emailItem?.sent_by_user?.last_name
                                          )}
                                        </p>
                                      </div>
                                    ) : (
                                      <div className="d-flex align-items-center">
                                        <UserChatBubble
                                          userId={emailItem?.sent_by_user?.id}
                                          first_name={emailItem?.sent_by_user?.first_name || ""}
                                          last_name={emailItem?.sent_by_user?.last_name || ""}
                                          profilePic={emailItem?.sent_by_user?.profile_pic ?? ""}
                                          isActive={
                                            userOnlineStatus?.[emailItem?.sent_by_user?.id]
                                              ?.isOnline ?? false
                                          }
                                          is_active={emailItem?.sent_by_user?.is_active}
                                          width={19}
                                        />
                                      </div>
                                    )}
                                  </td>

                                  <td className="text-center justify-content-center">
                                    <span className="d-flex align-items-center justify-content-center">
                                      <i
                                        className="ic ic-15 ic-email-3d"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                      />
                                    </span>
                                  </td>
                                  <td className="text-start">
                                    <span
                                      className=" white-space-text-overflow"
                                      style={{
                                        // fontWeight:
                                        //   emailItem?.from_user === "client" && !emailItem.is_read
                                        //     ? 700
                                        //     : 400,
                                        maxHeight: "100px",
                                      }}
                                    >
                                      {emailItem.subject}:{" "}
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: DOMPurify.sanitize(emailItem?.body || ""),
                                        }}
                                        style={{
                                          width: "100%",
                                          maxHeight: "79px",
                                          overflow: "hidden",
                                          pointerEvents: "none",
                                        }}
                                      />
                                    </span>
                                  </td>
                                </tr>
                              );
                            })}
                          </React.Fragment>
                        ))}
                      {(() => {
                        const grouped = email.reduce((acc, e) => {
                          const dateKey = new Date(e.date_received).toISOString().slice(0, 10);
                          if (!acc[dateKey]) acc[dateKey] = [];
                          acc[dateKey].push(e);
                          return acc;
                        }, {});
                        // const dateHeaderCount = Object.keys(grouped).length;
                        const messageCount = email.length;
                        const totalRows = messageCount;
                        const fakeRowsNeeded = Math.max(0, 8 - totalRows);
                        return [...Array(fakeRowsNeeded)]?.map((_, index) => (
                          <tr
                            key={`fake-row-${index}`}
                            className="fake-row-2"
                            style={{ height: "35px" }}
                          >
                            <td colSpan="6">&nbsp;</td>
                          </tr>
                        ));
                      })()}
                    </tbody>
                  </table>
                </div>
              </Tab.Pane>

              {/* LETTER TAB */}
              <Tab.Pane eventKey="letter">
                <div
                  className="table--no-card rounded-0 border-0"
                  style={{
                    scrollbarWidth: "none",
                    overflowY: "scroll",
                    maxHeight: "324px",
                  }}
                >
                  <table className="table table-borderless table-earning">
                    <thead className="sticked-head" style={{}}>
                      <tr id="tb-header">
                        <th
                          className=""
                          style={{ width: "25px", minWidth: "25px", maxWidth: "25px" }}
                        />
                        <th className=" text-center date-comm-tab-col">Date</th>
                        <th className=" text-center time-comm-tab-col">Time</th>
                        <th className=" text-center from-comm-tab-col">From</th>
                        <th
                          className=" text-center"
                          style={{ width: "25px", minWidth: "25px", maxWidth: "25px" }}
                        />
                        <th
                          className="text-center msg-comm-tab-col"
                          style={{ position: "relative" }}
                        >
                          Message
                          <PaginationWidget tabKey="letter" />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {letter.length > 0 &&
                        Object.entries(
                          letter.reduce((acc, item) => {
                            const dateKey = new Date(item.date).toISOString().slice(0, 10);
                            if (!acc[dateKey]) acc[dateKey] = [];
                            acc[dateKey].push(item);
                            return acc;
                          }, {})
                        )?.map(([date, items]) => (
                          <React.Fragment key={date}>
                            {items?.map((item, index) => {
                              letterIndex += 1;
                              return (
                                <tr
                                  style={{
                                    color: "var(--primary-80)",
                                    fontWeight: 400,
                                  }}
                                  key={`letter-${index}`}
                                >
                                  {/* <td>{index + 1}</td> */}
                                  <td id="client-comm-date-sep">{letterIndex}</td>
                                  <td
                                    className="text-end"
                                    // id="client-comm-date-sep"
                                  >
                                    {new Date(date).toLocaleDateString("en-US", {
                                      month: "short",
                                      day: "numeric",
                                      year: "numeric",
                                    })}
                                  </td>
                                  <td className="white-space-nowrap text-end">
                                    {/* <b className="text-transform-font-weight"> */}
                                    {new Date(item.date)
                                      .toLocaleTimeString("en-US", {
                                        hour: "numeric",
                                        minute: "2-digit",
                                        hour12: true,
                                      })
                                      .toLowerCase()}
                                    {/* </b> */}
                                  </td>
                                  <td className=" d-flex align-items-center">
                                    {item?.user?.user_type === "Client" ? (
                                      <div className="d-flex align-items-center">
                                        <div
                                          className="image-container-modal d-flex align-items-center justify-content-center"
                                          style={{
                                            width: "15px",
                                            height: "15px",
                                          }}
                                        >
                                          <img
                                            src={item?.user?.profile_pic ?? avatarImage}
                                            // alt={avatar}
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                              background: "var(--primary-30)",
                                            }}
                                          />
                                          {/* <div className="border-overlay-modal" /> */}
                                        </div>
                                        {/* <p className="ps-1">{item?.user?.last_name}</p>
                                        <span className="text-dark-grey">,</span>&nbsp;
                                        <p>{item?.user?.first_name}</p> */}
                                        <p className="ps-1">
                                          {getDisplayName(
                                            item?.user?.first_name,
                                            item?.user?.last_name
                                          )}
                                        </p>
                                      </div>
                                    ) : (
                                      <div className="d-flex align-items-center">
                                        <UserChatBubble
                                          userId={item?.user?.id}
                                          first_name={item?.user?.first_name || ""}
                                          last_name={item?.user?.last_name || ""}
                                          profilePic={item?.user?.profile_pic ?? ""}
                                          isActive={
                                            userOnlineStatus?.[item?.user?.id]?.isOnline ?? false
                                          }
                                          is_active={item?.user?.is_active}
                                          width={19}
                                        />
                                      </div>
                                    )}
                                  </td>
                                  <td className="text-center justify-content-center">
                                    <span className="d-flex align-items-center justify-content-center">
                                      <i
                                        className="ic ic-15 ic-file-colored"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                      />
                                    </span>
                                  </td>
                                  <td className="text-start">
                                    <div
                                      className="d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                      }}
                                    >
                                      {/* Check if this is a PDF (ends with .pdf) */}
                                      {item?.obj?.upload?.toLowerCase().endsWith(".pdf") ? (
                                        <>
                                          {/* PDF Button */}
                                          <button
                                            className="btn height-25 p-0 d-flex align-items-center justify-content-center"
                                            style={{
                                              border: "none",
                                              // padding: "0px 10px",
                                              // background: "var(--primary-25)",
                                              // minWidth: "35px",
                                            }}
                                            onClick={() => {
                                              addClickRecord(999, 2);
                                              handleDocPreview(item?.obj);
                                            }}
                                            title="Open PDF in a new tab"
                                          >
                                            <i className="ic ic-15 ic-generate-document-pdf" />
                                          </button>
                                          {/* Description */}
                                          <span className=" m-r-5">{item?.name}</span>
                                          <span className="">
                                            {item.description?.slice(0, 300)}
                                          </span>
                                          {/* Draft Button - Only show if from_draft exists */}
                                          {item?.obj?.from_draft && (
                                            <button
                                              className="btn height-25 p-0 d-flex align-items-center justify-content-center"
                                              style={{
                                                border: "none",
                                                // padding: "0px 10px",
                                                // background: "var(--primary-25)",
                                                // minWidth: "35px",
                                              }}
                                              onClick={() => {
                                                addClickRecord(999, 2);
                                                handleOpenDraft(
                                                  item?.obj?.from_draft?.id,
                                                  item?.obj?.from_draft?.template?.id,
                                                  item?.obj?.from_draft?.for_template,
                                                  item?.obj?.from_draft?.name
                                                );
                                              }}
                                              title="Open draft in word processor"
                                            >
                                              <img
                                                src={DraftsLogo}
                                                alt="Draft"
                                                style={{
                                                  width: "15px",
                                                  height: "15px",
                                                }}
                                              />
                                            </button>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {/* Original letter display for non-PDF drafts */}
                                          {item?.doc_id !== null && (
                                            <div className="icon-text-boxes d-flex flex-wrap w-100 e-template-row height-25">
                                              <div
                                                className="col-12 col-md-3 col-xl icon-text-box text-center height-25 font-weight-semibold cursor-pointer btn-hover-document-row"
                                                id="no-vertical-border"
                                                style={{
                                                  borderColor: "var(--primary)",
                                                  backgroundColor: "var(--primary-10)",
                                                  color: "var(--primary)",
                                                  border: "1px solid var(--primary)",
                                                  maxWidth: "255px",
                                                }}
                                                onClick={() => {
                                                  addClickRecord(999, 2);
                                                  handleOpenDraft(
                                                    item?.obj?.draft_itself?.id,
                                                    item?.obj?.id,
                                                    item?.obj?.draft_itself?.for_template,
                                                    item?.obj?.draft_itself?.name
                                                  );
                                                }}
                                              >
                                                <p className="date">{item?.obj?.created}</p>
                                                <span
                                                  className="icon-wrap"
                                                  style={{
                                                    height: "15px",
                                                    width: "15px",
                                                    maxWidth: "15px",
                                                    flex: "0 0 15px",
                                                    margin: 0,
                                                  }}
                                                >
                                                  <i className="ic ic-15 ic-file-colored cursor-pointer" />
                                                </span>
                                                <p className="name">{item?.obj?.file_name}</p>
                                              </div>
                                            </div>
                                          )}
                                          <span className=" m-r-5">{item?.name}</span>
                                          <span className="">
                                            {item.description?.slice(0, 300)}
                                          </span>
                                        </>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </React.Fragment>
                        ))}
                      {[...Array(Math.max(0, 8 - letter.length))]?.map((_, index) => (
                        <tr
                          key={`additional-${index}`}
                          className="fake-row-2"
                          style={{ height: "35px" }}
                        >
                          <td colSpan="6">&nbsp;</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Tab.Pane>

              {/* PHONE CALL TAB */}
              <Tab.Pane eventKey="phone_call">
                <div
                  className="table--no-card rounded-0 border-0"
                  style={{
                    scrollbarWidth: "none",
                    overflowY: "scroll",
                    maxHeight: "324px",
                  }}
                >
                  <table className="table table-borderless table-earning">
                    <thead className="sticked-head" style={{}}>
                      <tr id="tb-header">
                        <th
                          className=""
                          style={{ width: "25px", minWidth: "25px", maxWidth: "25px" }}
                        />
                        <th className=" text-center date-comm-tab-col">Date</th>
                        <th className=" text-center time-comm-tab-col">Time</th>
                        <th className=" text-center from-comm-tab-col">From</th>
                        <th
                          className=" text-center"
                          style={{ width: "25px", minWidth: "25px", maxWidth: "25px" }}
                        />
                        <th
                          className="text-center msg-comm-tab-col"
                          style={{ position: "relative" }}
                        >
                          Message
                          <PaginationWidget tabKey="phone_call" />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {phone.length > 0 &&
                        Object.entries(
                          phone.reduce((acc, item) => {
                            const dateKey = new Date(item.date).toISOString().slice(0, 10);
                            if (!acc[dateKey]) acc[dateKey] = [];
                            acc[dateKey].push(item);
                            return acc;
                          }, {})
                        )?.map(([date, items]) => (
                          <React.Fragment key={date}>
                            {items?.map((item, index) => {
                              phoneCallIndex += 1;
                              const unread = isUnread(item);
                              return (
                                <tr
                                  style={{
                                    color: unread ? "black" : "var(--primary-80)",
                                    fontWeight: unread ? 700 : 400,
                                  }}
                                  key={`phone-${index}`}
                                  onClick={() => setShowPhoneCallModal(true)}
                                >
                                  <td id="client-comm-date-sep">{phoneCallIndex}</td>
                                  <td
                                    className="text-end"
                                    // id="client-comm-date-sep"
                                  >
                                    {new Date(date).toLocaleDateString("en-US", {
                                      month: "short",
                                      day: "numeric",
                                      year: "numeric",
                                    })}
                                  </td>
                                  <td className="white-space-nowrap text-end">
                                    {/* <b className="text-transform-font-weight"> */}
                                    {new Date(item.date)
                                      .toLocaleTimeString("en-US", {
                                        hour: "numeric",
                                        minute: "2-digit",
                                        hour12: true,
                                      })
                                      .toLowerCase()}
                                    {/* </b> */}
                                  </td>
                                  <td className=" d-flex align-items-center">
                                    {item?.user?.user_type === "Client" ? (
                                      <div className="d-flex align-items-center">
                                        <div
                                          className="image-container-modal d-flex align-items-center justify-content-center"
                                          style={{
                                            width: "15px",
                                            height: "15px",
                                          }}
                                        >
                                          <img
                                            src={item?.user?.profile_pic ?? avatarImage}
                                            // alt={avatar}
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                              background: "var(--primary-30)",
                                            }}
                                          />
                                          {/* <div className="border-overlay-modal" /> */}
                                        </div>
                                        {/* <p className="ps-1">{item?.user?.last_name}</p>
                                        <span className="text-dark-grey">,</span>&nbsp;
                                        <p>{item?.user?.first_name}</p> */}
                                        <p className="ps-1">
                                          {getDisplayName(
                                            item?.user?.first_name,
                                            item?.user?.last_name
                                          )}
                                        </p>
                                      </div>
                                    ) : (
                                      <div className="d-flex align-items-center">
                                        <UserChatBubble
                                          userId={item?.user?.id}
                                          first_name={item?.user?.first_name || ""}
                                          last_name={item?.user?.last_name || ""}
                                          profilePic={item?.user?.profile_pic ?? ""}
                                          isActive={
                                            userOnlineStatus?.[item?.user?.id]?.isOnline ?? false
                                          }
                                          is_active={item?.user?.is_active}
                                          width={19}
                                        />
                                      </div>
                                    )}
                                  </td>
                                  <td className="text-center justify-content-center">
                                    <span className="d-flex align-items-center justify-content-center">
                                      <NewPhoneIcon />
                                    </span>
                                  </td>
                                  <td className="text-start">
                                    <span className="">
                                      {formatPhoneNumber
                                        ? formatPhoneNumber(item?.contact_id?.phone_number)
                                        : item?.contact_id?.phone_number}
                                      : <span className="">{item?.description?.slice(0, 300)}</span>
                                    </span>
                                  </td>
                                </tr>
                              );
                            })}
                          </React.Fragment>
                        ))}

                      {call.length > 0 &&
                        Object.entries(
                          call.reduce((acc, item) => {
                            const dateKey = new Date(item.date).toISOString().slice(0, 10);
                            if (!acc[dateKey]) acc[dateKey] = [];
                            acc[dateKey].push(item);
                            return acc;
                          }, {})
                        )?.map(([date, items]) => (
                          <React.Fragment key={date}>
                            {items?.map((item, index) => {
                              CallIndex += 1;
                              const unread = isUnread(item);
                              return (
                                <tr
                                  onClick={() => {
                                    markItemAsReviewed(item);
                                  }}
                                  style={{
                                    color: unread ? "black" : "var(--primary-80)",
                                    fontWeight: unread ? 700 : 400,
                                  }}
                                  key={`phone-${index}`}
                                >
                                  <td id="client-comm-date-sep">{CallIndex}</td>
                                  <td
                                    className="text-end"
                                    // id="client-comm-date-sep"
                                  >
                                    {new Date(date).toLocaleDateString("en-US", {
                                      month: "short",
                                      day: "numeric",
                                      year: "numeric",
                                    })}
                                  </td>
                                  <td className="white-space-nowrap text-end">
                                    {/* <b className="text-transform-font-weight"> */}
                                    {new Date(item.obj?.created_at)
                                      .toLocaleTimeString("en-US", {
                                        hour: "numeric",
                                        minute: "2-digit",
                                        hour12: true,
                                      })
                                      .toLowerCase()}
                                    {/* </b> */}
                                  </td>
                                  <td className=" d-flex align-items-center">
                                    {item.type === "InboundRecordedCall" ? (
                                      <>{getFromValue(item)}</>
                                    ) : (
                                      <div className="d-flex align-items-center">
                                        <UserChatBubble
                                          userId={item?.obj?.initiated_by?.id}
                                          first_name={item?.obj?.initiated_by?.first_name || ""}
                                          last_name={item?.obj?.initiated_by?.last_name || ""}
                                          profilePic={item?.obj?.initiated_by?.profile_pic ?? ""}
                                          isActive={
                                            userOnlineStatus?.[item?.obj?.initiated_by?.id]
                                              ?.isOnline ?? false
                                          }
                                          is_active={item?.obj?.initiated_by?.is_active}
                                          width={19}
                                        />
                                      </div>
                                    )}
                                  </td>
                                  <td className="text-center justify-content-center">
                                    <span className="d-flex align-items-center justify-content-center">
                                      {item.obj?.status === "no_answer" ? (
                                        <NewRejectedIcon />
                                      ) : (
                                        <NewPhoneIcon />
                                      )}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      fontWeight: unread ? 700 : 400,
                                    }}
                                    className="text-start"
                                  >
                                    <div className="d-flex align-items-center justify-content-between">
                                      <span className=" call-index-name">
                                        {formatPhoneNumber3
                                          ? formatPhoneNumber3(item?.obj?.client_phone_number)
                                          : item?.obj?.client_phone_number}
                                        :{" "}
                                        <span className="">
                                          {item?.obj?.final_message?.slice(0, 300)}
                                        </span>
                                      </span>
                                      <div
                                        className="d-flex align-items-center justify-content-center"
                                        style={{
                                          gap: "5px",
                                        }}
                                      >
                                        <button
                                          className="btn btn-secondary height-25  d-flex align-items-center justify-content-center"
                                          style={{
                                            border: "none",
                                            gap: "5px",
                                            width: "max-content",
                                            padding: "0px 5px",
                                            // background: "var(--primary-25)",
                                            // minWidth: "35px",
                                          }}
                                          onClick={() => {
                                            setSelectedCall(item?.obj);
                                            setTranscriptionModal(true);
                                          }}
                                          disabled={!item?.obj?.transcript_available}
                                          title="Transcript Preview"
                                        >
                                          <img
                                            src={transcptionIcon}
                                            style={{
                                              position: "relative",
                                              left: "1px",
                                            }}
                                            className="ic ic-15 d-flex align-items-center justify-content-center"
                                          />
                                          <span className="comm-btn-text">Transcript</span>
                                        </button>
                                        <button
                                          className="btn btn-secondary height-25  d-flex align-items-center justify-content-center"
                                          style={{
                                            border: "none",
                                            gap: "5px",
                                            padding: "0px 5px",
                                            width: "max-content",
                                            // background: "var(--primary-25)",
                                            // minWidth: "35px",
                                          }}
                                          // onClick={() => {
                                          //   handlePhoneRecordingPlay(item?.obj);
                                          // }}
                                          onClick={() => {
                                            setSelectedRecordingCall(item?.obj);
                                            setRecordingModalOpen(true);
                                          }}
                                          disabled={!item?.obj?.recording_available}
                                          title="Recording Available"
                                        >
                                          <img
                                            src={phoneRecordIcon}
                                            className="ic ic-15 d-flex align-items-center justify-content-center"
                                          />
                                          <span className="comm-btn-text">Recording</span>
                                        </button>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </React.Fragment>
                        ))}
                      {[...Array(Math.max(0, 8 - phone.length - call?.length))]?.map((_, index) => (
                        <tr
                          key={`additional-${index}`}
                          className="fake-row-2"
                          style={{ height: "35px" }}
                        >
                          <td colSpan="6">&nbsp;</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
      {showCommunicationModal && (
        <>
          {showCommunicationModal && (
            <CommunicationModal
              show={showCommunicationModal}
              handleClose={() => {
                addClickRecord(999, 2);
                setShowCommunicationModal(false);
                // setCommInitialTab(null);
              }}
              clientData={clientData}
              refetch={() => {}}
            />
          )}
        </>
      )}
      {textViewResponseModalShow && (
        <TextViewResponseModal
          show={textViewResponseModalShow}
          handleClose={() => {
            addClickRecord(999, 2);
            setTextViewResponseModalShow(false);
          }}
          message={selectedMessage}
          refetchMessages={() => {}} // No-op: WebSocket handles updates
        />
      )}
      {emailReplyModalShow && (
        <EmailReplyModal
          show={emailReplyModalShow}
          handleClose={() => {
            addClickRecord(999, 2);
            setEmailReplyModalShow(false);
          }}
          email={selectedEmail}
          refetchEmails={() => {}} // No-op: WebSocket handles updates
          refetchUnreadCount={fetchUnreadCount}
          client_pic={clientData?.client?.profile_pic}
          clientName={clientData?.client?.first_name + " " + clientData?.client?.last_name}
          client_email={clientData?.client?.primary_email?.email}
        />
      )}
      {showChatModal && (
        <ModalBodyMessage
          show={showChatModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setShowChatModal(false);
          }}
          clientName={clientData?.client?.first_name + " " + clientData?.client?.last_name}
          typeComm={"Chat"}
          mainHead={"CHAT"}
          client_pic={clientData?.client?.profile_pic}
          refetch={() => {}} // No-op: WebSocket handles updates
        />
      )}
      {showTextModal && (
        <ModalBodyMessage
          show={showTextModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setShowTextModal(false);
          }}
          clientName={clientData?.client?.first_name + " " + clientData?.client?.last_name}
          typeComm={"Text"}
          mainHead={"TEXT"}
          primary_number={clientData?.client?.primary_phone?.phone_number}
          client_pic={clientData?.client?.profile_pic}
          refetch={() => {}} // No-op: WebSocket handles updates
        />
      )}
      {showEmailModal && (
        <NewEmailModal
          show={showEmailModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setShowEmailModal(false);
          }}
          clientName={clientData?.client?.first_name + " " + clientData?.client?.last_name}
          primary_email={clientData?.client?.primary_email?.email}
          client_pic={clientData?.client?.profile_pic}
          refetch={() => {}} // No-op: WebSocket handles updates
        />
      )}
      {showPhoneCallModal && (
        <>
          <AddPhoneCallModal
            show={showPhoneCallModal}
            handleClose={() => {
              addClickRecord(999, 2);
              setShowPhoneCallModal(false);
            }}
            clientData={clientData.client}
            clientId={clientId}
            caseId={caseId}
            refetch_data={() => {}} // No-op: WebSocket handles updates
          />
        </>
      )}
      {showLetterModal && (
        <>
          <AddLetterPopup
            show={showLetterModal}
            clientId={clientId}
            caseId={caseId}
            handleClose={() => {
              addClickRecord(999, 2);
              setShowLetterModal(false);
            }}
            refetch_data={() => {}} // No-op: WebSocket handles updates
          />
        </>
      )}

      {transcriptionModal && (
        <TranscriptionModal
          show={transcriptionModal}
          onClose={() => {
            setTranscriptionModal(false);
            setSelectedCall(null);
          }}
          selectedCall={selectedCall}
          clientData={clientData}
        />
      )}

      {recordingModalOpen && (
        <RecordingPlayerModal
          show={recordingModalOpen}
          onClose={() => setRecordingModalOpen(false)}
          callData={selectedRecordingCall}
          fetchRecording={fetchRecording}
          clientData={clientData}
        />
      )}
    </>
  );
};

export default ClientCommunication;
